/**
 * Whether like and user-comment actions should show in the player sidebar.
 * API may send boolean, 0/1, or omit the field (default: show).
 */
export function isPlayerShowSidebarEnabled(value) {
  if (value == null) return true;
  if (value === false || value === 0) return false;
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (s === "0" || s === "false" || s === "no" || s === "off") return false;
    if (s === "1" || s === "true" || s === "yes" || s === "on") return true;
  }
  return true;
}
